import * as instrument from "../../../../assessments/instruments/sample/core-1-1-r1.js";
import type { Decorator } from "../../decorator.js";
import { formOrder } from "../../decorators/formOrder.js";
import type { SupportedVersions } from "../../supportedVersions.js";

const { groups, items } = instrument;

/** The order the instrument module lists, which a stored schema does not keep. */
export const order: Decorator = formOrder(instrument, {
  groups: [groups.life_functioning, groups.trauma],
  items: [
    items.school_attendance,
    items.school_engagement,
    items.family_history,
    items.adjustment_to_trauma,
  ],
});

/** Family history is always asked: this version requires it, so it cannot be hidden. */
export const sampleCore_1_1: SupportedVersions = {
  versions: [["sample", "core", "1.1"]],
  decorators: [order],
};
